import { render, staticRenderFns } from "./suitableJobs.vue?vue&type=template&id=7f4b0617"
import script from "./suitableJobs.vue?vue&type=script&lang=js"
export * from "./suitableJobs.vue?vue&type=script&lang=js"
import style0 from "./suitableJobs.vue?vue&type=style&index=0&id=7f4b0617&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports